// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"entityDetails_mulitpleDropdown__2U6Gm","loaderWrapper":"entityDetails_loaderWrapper__32jFK","content":"entityDetails_content__22NbX"};